import React, { useState } from "react";
import { saveAs } from "file-saver";
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  Table,
  TableRow,
  TableCell,
  WidthType,
  ImageRun,
  NumberFormat,
  Footer,
  AlignmentType,
  PageNumber,
  FrameAnchorType,
  HorizontalPositionAlign,
  VerticalPositionAlign,
  UnderlineType,
  convertInchesToTwip,
  TableRowHeight,
  VerticalAlign,
  BorderStyle,
  TableLayoutType,
  ShadingType,
  VerticalMerge,
  VerticalMergeType,
} from "docx";

const ModelWord3 = (
  jsonData,
  customHeader = [{ cell1: "Header 1", cell2: "Header 2" }],
  customFooter = []
) => {
  function extractAllKeys(data) {
    const allKeys = new Set();

    data?.forEach((item) => {
      Object.keys(item).forEach((key) => {
        allKeys.add(key);
      });
    });

    return Array.from(allKeys);
  }

  const tempHeader = extractAllKeys(jsonData.tableContent);

  const numColumns = tempHeader.length;

  const headerCustomTable = customHeader.map(
    (row) =>
      new TableRow({
        height: { value: 1500, rule: TableRowHeight.EXACT },
        children: Object.entries(row).map(
          ([key, value]) =>
            new TableCell({
              verticalAlign: VerticalAlign.CENTER,
              shading: {
                fill: "f44336",
              },
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: value,
                      bold: true,
                      color: "FFFFFF",
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            })
        ),
      })
  );

  const newTable = new Table({
    width: { size: 1000, type: WidthType.PERCENTAGE },
    layout: TableLayoutType.FIXED,
    style: "arial",
    rows: [
      //   new TableRow({
      //     children: [
      //       new TableCell({
      //         shading: {
      //           fill: "f44336",
      //         },
      //         children: [
      //           new Paragraph({
      //             children: [
      //               new TextRun({
      //                 text: "Emri i Subjektit (OSHMA)",
      //                 bold: true,
      //                 color: "FFFFFF",
      //               }),
      //             ],
      //             alignment: AlignmentType.CENTER,
      //           }),
      //         ],
      //         rowSpan: 2, // Merge with the next row
      //         verticalAlign: VerticalAlign.CENTER, // Center text vertically
      //       }),
      //       new TableCell({
      //         shading: {
      //           fill: "f44336",
      //         },
      //         children: [
      //           new Paragraph({
      //             children: [
      //               new TextRun({
      //                 text: "Kontakte",
      //                 bold: true,
      //                 color: "FFFFFF",
      //               }),
      //             ],
      //             alignment: AlignmentType.CENTER,
      //           }),
      //         ],
      //       }),
      //     ],
      //   }),

      // Second Row (No first cell as it's merged)
      //   new TableRow({
      //     children: [
      //       new TableCell({
      //         shading: {
      //           fill: "f44336",
      //         },
      //         children: [
      //           new Paragraph({
      //             children: [
      //               new TextRun({
      //                 text: "Adrese",
      //                 bold: true,
      //                 color: "FFFFFF",
      //               }),
      //             ],
      //             alignment: AlignmentType.CENTER,
      //           }),
      //         ],
      //       }),
      //       new TableCell({
      //         shading: {
      //           fill: "f44336",
      //         },
      //         children: [
      //           new Paragraph({
      //             children: [
      //               new TextRun({
      //                 text: "Telefoni",
      //                 bold: true,
      //                 color: "FFFFFF",
      //               }),
      //             ],
      //             alignment: AlignmentType.CENTER,
      //           }),
      //         ],
      //       }),
      //       new TableCell({
      //         shading: {
      //           fill: "f44336",
      //         },
      //         children: [
      //           new Paragraph({
      //             children: [
      //               new TextRun({
      //                 text: "Emaili",
      //                 bold: true,
      //                 color: "FFFFFF",
      //               }),
      //             ],
      //             alignment: AlignmentType.CENTER,
      //           }),
      //         ],
      //       }),
      //     ],
      //   }),

      //   new TableRow({
      //     height: { value: 1500, rule: TableRowHeight.EXACT },
      //     children: [
      //       new TableCell({
      //         columnSpan: numColumns,
      //         verticalMerge: VerticalMerge.RESTART, // Enforce merge in Word
      //         verticalAlign: VerticalAlign.CENTER,
      //         shading: {
      //           fill: "f44336",
      //         },
      //         children: [
      //           new Paragraph({
      //             children: [
      //               new TextRun({
      //                 text: "Table Test Model 2",
      //                 bold: true,
      //                 color: "FFFFFF",
      //               }),
      //             ],
      //             alignment: AlignmentType.CENTER,
      //           }),
      //         ],
      //       }),
      //     ],
      //   }),
      //   ...headerCustomTable,
      //   new TableRow({
      //     height: { value: 1500, rule: TableRowHeight.EXACT },
      //     children: customHeader.map(
      //       (customHeader) =>
      //         new TableCell({
      //           verticalAlign: VerticalAlign.CENTER,
      //           shading: {
      //             fill: "f44336",
      //           },
      //           children: [
      //             new Paragraph({
      //               children: [
      //                 new TextRun({
      //                   text: customHeader,
      //                   bold: true,
      //                   color: "FFFFFF",
      //                 }),
      //               ],
      //               alignment: AlignmentType.CENTER,
      //             }),
      //           ],
      //         })
      //     ),
      //   }),
      new TableRow({
        height: { value: "150pt", rule: TableRowHeight.ATLEAST },
        children: tempHeader.map(
          (header) =>
            new TableCell({
              verticalAlign: VerticalAlign.CENTER,
              shading: {
                fill: "f44336",
              },
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: header,
                      bold: true,
                      color: "FFFFFF",
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            })
        ),
      }),
      ...jsonData.tableContent.map(
        (row) =>
          new TableRow({
            children: Object.entries(row).map(
              ([key, value]) =>
                new TableCell({
                  children: [new Paragraph(value)],
                  borders: {
                    top: {
                      style: BorderStyle.SINGLE,
                      size: 3,
                      color: "000000",
                    },
                    bottom: {
                      style: BorderStyle.SINGLE,
                      size: 3,
                      color: "000000",
                    },
                    left: {
                      style: BorderStyle.NONE,
                      size: 1,
                      color: "FFFFFF",
                    },
                    right: {
                      style: BorderStyle.NONE,
                      size: 1,
                      color: "FFFFFF",
                    },
                  },
                })
            ),
            borders: {
              bottom: {
                style: BorderStyle.SINGLE,
                size: 6,
                color: "000000",
              },
            },
          })
      ),
      new TableRow({
        height: { value: "150pt", rule: TableRowHeight.ATLEAST },
        children: [
          new TableCell({
            verticalAlign: VerticalAlign.CENTER,
            shading: {
              fill: "f44336",
            },
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Shuma 300000 leke",
                    bold: true,
                    color: "FFFFFF",
                  }),
                ],
                alignment: AlignmentType.RIGHT,
              }),
            ],
          }),
        ],
      }),
    ],
  });

  return [newTable];
};

export default ModelWord3;
